var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlueBoatHat = function SvgBlueBoatHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 44,
    viewBox: "0 0 65 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.8418L0 20.5243L21.9491 19.8312L17.3282 28.8418Z",
    fill: "url(#boat_hat_paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4163 0.716187L9.08734 27.8064L32.4163 35.7794V0.716187Z",
    fill: "url(#boat_hat_paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.6109L42.2808 19.6002L64.6919 18.676L49.6741 28.6109Z",
    fill: "url(#boat_hat_paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3146 36.3756L32.4042 1.02448L52.4382 29.637L36.2655 38.7387L32.3146 36.3756Z",
    fill: "url(#boat_hat_paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1151 0.940994L8.78619 28.0312L32.1151 36.0042V0.940994Z",
    fill: "url(#boat_hat_paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.6274L0.308044 20.8938L30.571 25.2281L65 19.0454L58.1494 37.919L31.7913 43.2883L7.62973 39.6274Z",
    fill: "url(#boat_hat_paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.6274L0.308044 20.8938L30.571 25.2281L65 19.0454L58.1494 37.919L31.7913 43.2883L7.62973 39.6274Z",
    fill: "url(#boat_hat_paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 39.3191L0 20.5854L30.263 24.9198L64.692 18.7371L57.8413 37.6107L31.4833 42.9799L7.32169 39.3191Z",
    fill: "url(#boat_hat_paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint0_linear",
    x1: 4.35976,
    y1: 16.312,
    x2: 16.4482,
    y2: 26.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint1_linear",
    x1: 27.4932,
    y1: -9.4494,
    x2: 27.9553,
    y2: 64.5592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint2_linear",
    x1: 59.8476,
    y1: 18.6901,
    x2: 45.7774,
    y2: 23.4462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint3_linear",
    x1: 39.8323,
    y1: 0.854704,
    x2: 23.3842,
    y2: 109.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint4_linear",
    x1: 25.3658,
    y1: 18.2937,
    x2: 2.07938,
    y2: -9.68035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint5_linear",
    x1: 32.6531,
    y1: 4.78222,
    x2: 32.6531,
    y2: 36.9733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint6_linear",
    x1: 32.6531,
    y1: 10.7892,
    x2: 32.6531,
    y2: 54.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint7_linear",
    x1: -39.6612,
    y1: 28.3636,
    x2: 91.5673,
    y2: 28.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueBoatHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blue_boat_hat.3fb3b10f.svg";
export { ForwardRef as ReactComponent };